import React, { useEffect } from 'react';
import { Box } from '@marvelapp/ui';
import { FullScreenLoader } from '@marvelapp/ui-internal';
import { handleFigmaEvents } from '../utils/createFigmaEventEmitter';
export default function ExternalPrototype(_a) {
    var goalScreenPk = _a.goalScreenPk, screens = _a.screens, setHasLoadedExternalPrototype = _a.setHasLoadedExternalPrototype, setExternalPrototypeLoading = _a.setExternalPrototypeLoading, loadingStatus = _a.loadingStatus, src = _a.src;
    useEffect(function () {
        var handleEvents = function (e) {
            return handleFigmaEvents(e, setHasLoadedExternalPrototype, screens, goalScreenPk);
        };
        window.addEventListener('message', handleEvents);
        return function () { return window.removeEventListener('message', handleEvents); };
    }, [screens, setHasLoadedExternalPrototype, goalScreenPk]);
    // Don't use replaceAll as this is not supported in slightly older browsers
    var encodedSrc = src.replace(new RegExp('&', 'g'), '%26');
    return (React.createElement(React.Fragment, null,
        loadingStatus === 'pending' && (React.createElement(Box, { bg: "#FFFFFF", height: "100%", left: "0", position: "absolute", top: "0", width: "100%" },
            React.createElement(FullScreenLoader, null))),
        React.createElement("iframe", { allowFullScreen: true, src: "https://figma.com/embed?embed_host=share&url=".concat(encodedSrc), onLoad: setExternalPrototypeLoading, style: {
                height: '100%',
                width: '100vw',
            } })));
}
